import React, { useEffect, useState } from 'react';
import { CONFIG } from '../utils/config';
import { Button, Row, Col } from 'react-bootstrap';
import ReviewForm from './ReviewForm';
import ReviewsList from './ReviewsList';

const ReviewsDisplay = props => {
  const { orgId } = props;

  const [comments, setComments] = useState();
  const [reviewForm, showReviewForm] = useState(false);
  const [loading, setLoading] = useState(true);
  const [noComments, setNoComments] = useState();

  useEffect(() => {
    const getReviews = async () => {
      const response = await fetch(`${CONFIG.API_URL}${CONFIG.COMMENTS_PATH}`);
      const comments = await response.json();
      const filteredComments = comments.data.filter(comment => {
        return comment.relationships.entity_id.data.id === orgId;
      });
      if (filteredComments.length === 0) {
        setNoComments(true);
      }
      else {
        setComments(filteredComments);
      }

    };
    getReviews();
    setLoading(false);
  }, []);

  const ReviewsFormDisplay = () => {
    if (reviewForm === true) {
      return <ReviewForm orgId={orgId} />;
    } else {
      return <></>;
    }
  };

  return (
    <>
      <Row>{!loading && !reviewForm && !noComments && <ReviewsList data={comments} />}</Row>
      <Row>
        <Col>
          {noComments && (
            <p>Be the first to rate and review this organisation.</p>
          )}
          {!reviewForm && (
            <Button
              className="btn btn-primary"
              onClick={() => {
                showReviewForm(true);
              }}
            >
              Add Review
            </Button>
          )}
          {reviewForm && (
            <Button
              className="btn btn-primary"
              onClick={() => {
                showReviewForm(false);
              }}
            >
              View Reviews
            </Button>
          )}
        </Col>
      </Row>
      <Row>
        <ReviewsFormDisplay />
      </Row>
    </>
  );
};

export default ReviewsDisplay;
